export const getTicketRandomly = <T,>(arr: T[], count: number): T[] => {
  if (count > arr.length) {
    throw new Error("O número de itens solicitados é maior que a quantidade de ticket disponível.");
  }

  const randomItems = new Set<T>();

  while (randomItems.size < count) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    randomItems.add(arr[randomIndex]);
  }

  return Array.from(randomItems);
};
